// extracted by mini-css-extract-plugin
export default {"group":"Group_group__yW6YH","title":"Group_title__s5aHl"};